var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Api } from './Api';
import Cookies from 'js-cookie';
export class AuthenticatedApi extends Api {
    constructor(accessToken, baseAddress, impersonatedAs) {
        super(baseAddress);
        this.accessToken = accessToken;
        this.handleUnauthenticated = undefined;
        this.impersonatedAs = impersonatedAs;
    }
    appendHeaders(headers = {}) {
        let resolvedHeaders = super.appendHeaders(headers);
        const accessToken = Cookies.get('accessToken');
        if (accessToken) {
            resolvedHeaders['Authorization'] = `Bearer ${accessToken}`;
            if (this.impersonatedAs) {
                resolvedHeaders['ImpersonatedAs'] = this.impersonatedAs;
            }
        }
        return resolvedHeaders;
    }
    executeRequest(response) {
        return __awaiter(this, void 0, void 0, function* () {
            var result = yield response();
            if (result.status === 401 && this.accessToken) {
                if (this.handleUnauthenticated) {
                    let cont = true;
                    do {
                        cont = yield this.handleUnauthenticated();
                        if (cont) {
                            result = yield response();
                        }
                        yield new Promise(r => setTimeout(r, 1000));
                    } while (cont && result.status === 401 && this.accessToken);
                }
            }
            this.checkStatus(result);
            return result;
        });
    }
}
